import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./customFetchBase";

export const usersApi = createApi({
  reducerPath: "usersApi",
  baseQuery,
  tagTypes: ["User", "Rider", "PendingRider", "Admin"],
  endpoints: (builder) => ({
    allUsers: builder.query({
      query: () => "/user/users",
      providesTags: ["User"],
    }),
    riders: builder.query({
      query: () => "/rider/riders",
      providesTags: ["Rider"],
    }),
    admins: builder.query({
      query: () => "/user/admins",
      providesTags: ["Admin"],
    }),
    fetchDocuments: builder.query({
      query: (data) => `/rider/fetch-docs?riderId=${data}`,
    }),
    unapprovedRiders: builder.query({
      query: () => "/rider/pending-riders",
      providesTags: ["PendingRider"],
    }),
    updateProfile: builder.mutation({
      query: (data) => ({
        url: "/user/update-profile",
        method: "POST",
        body: data,
      }),
    }),
    uploadMedia: builder.mutation({
      query: (data) => ({
        url: "/media/upload-media",
        method: "POST",
        body: data,
      }),
    }),
    delUser: builder.mutation({
      query: (data) => ({
        url: "/user/del-user",
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: ["User", "Rider", "PendingRider", "Admin"],
    }),
    changeStatus: builder.mutation({
      query: (data) => ({
        url: "/user/update-status",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["User", "Rider", "PendingRider", "Admin"],
    }),
  }),
});

export const {
  useAllUsersQuery,
  useRidersQuery,
  useAdminsQuery,
  useFetchDocumentsQuery,
  useUnapprovedRidersQuery,
  useUpdateProfileMutation,
  useUploadMediaMutation,
  useDelUserMutation,
  useChangeStatusMutation,
} = usersApi;
